export const routes =  (prefix = `billing`) => [
    {
        path: `/${prefix}/receive-deposit/:patientID/:visitNO`,
        name: `${prefix}.receive-deposits.index`,
        component: () => import('./Form.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.receive-deposits.index`,
                PageDescription: "Accounts: Receive deposits",
            },
        },
    },
];
